export default __webpack_public_path__ + "static/media/logo.a522b69a.webp";